export const WHITELIST_GET_STATUS = 'WHITELIST_ADDRESS/GET_STATUS'
export const WHITELIST_SUBMIT = 'WHITELIST_ADDRESS/SUBMIT'
